import { render } from "./mentalHealthDetail.vue?vue&type=template&id=3614aca6&scoped=true"
import script from "./mentalHealthDetail.vue?vue&type=script&lang=js"
export * from "./mentalHealthDetail.vue?vue&type=script&lang=js"

import "./mentalHealthDetail.vue?vue&type=style&index=0&id=3614aca6&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3614aca6"]])

export default __exports__